import { render, staticRenderFns } from "./classification-select-container.vue?vue&type=template&id=7ab348be"
import script from "./classification-select-container.vue?vue&type=script&lang=js"
export * from "./classification-select-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports